export const TIME_TYPES = {
    asap: 'asap', // Как можно скорее
    ontime: 'ontime', // В указанное время
    interval: 'interval', // В указанный интервал (кулинария)
}
